/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import * as React from 'react';
import { Box, BoxProps } from 'grommet';
import { ErrorMessage } from '@blend/alchemy';

export namespace AlertBar {
  export interface Props extends React.HTMLAttributes<HTMLDivElement> {
    boxProps?: BoxProps;
    errorMessage: string;
    id: string;
  }
}

export const AlertBar: React.FC<AlertBar.Props> = ({ boxProps, id, errorMessage, ...htmlProps }) => {
  const { className } = htmlProps;
  return (
    <Box
      background="accentRed07"
      border={{ color: 'accentRed' }}
      className={className}
      id={`${id}-errorMsg`}
      margin={{ left: 'medium', right: 'medium', top: 'medium' }}
      pad={{ horizontal: 'medium', vertical: 'small' }}
      {...boxProps}
    >
      <ErrorMessage errorMessage={errorMessage} withIcon={true} />
    </Box>
  );
};
